<template>
  <div>
    <wxlogin
      :appid="appid"
      :scope="scope"
      :redirect_uri="redirect_uri"
    ></wxlogin>
  </div>
</template>
<script>
import wxlogin from "vue-wxlogin";
export default {
  data() {
    return {
      appid: "wx453e5e95c54357ae",
      scope: "snsapi_login",
      redirect_uri: encodeURIComponent("http://jsp.weiao.tech/"),
      state: Math.ceil(Math.random() * 1000),
      style: "white",
      href: "data:text/css;base64,LmltcG93ZXJCb3h7cG9zaXRpb246cmVsYXRpdmU7d2lkdGg6MTUwcHh9Ci5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9Ci5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAxNTBweDttYXJnaW4tdG9wOjVweDtib3JkZXI6MXB4fQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDE1MHB4O21hcmdpbjowIGF1dG99Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1cyB7ZGlzcGxheTogbm9uZX0K",
    };
  },
  components: { wxlogin },
};
</script>
